import React from "react";
import { Shortcut } from "../../../application/domain/ttzk-portal";
import { StatusTag } from "@graffer-inc/console-design-kit";

type Props = {
  shortcut: Shortcut;
};

export const PublishStatusTag: React.FC<Props> = ({ shortcut }) => {
  if (shortcut.isPublished) {
    return (
      <StatusTag type="SUCCESS" hiddenCheckIcon>
        公開中
      </StatusTag>
    );
  } else {
    return <StatusTag type="SECONDARY">下書き</StatusTag>;
  }
};

export default PublishStatusTag;
